<style lang="stylus" scoped>
.pay_modal
    .ivu-modal-body
        .pay_main
            padding: 10px 15px 20px
            min-height 491px
            text-align center
            .main_tit
                // color #ff5a00
                color #ff0000
                font-size 14px
                text-align left
                .pay_num
                    color #959595
                    font-size 12px
            .pay_table
                margin-top 20px
                .ivu-table
                    .pay-table-row
                        font-size 12px
            .money
                font-weight bold
                &.original
                    margin-top 20px
                    font-size 14px
                    color #ff6464
                    text-decoration line-through
                    span
                        color #7c7c7c
                &.now
                    margin 24px 0
                    font-size 18px
                    // color #ff6464
                    color #ff0000
            .pay_img
                margin 30px auto 0
                width 345px
                line-height 45px
                .pay_img_zfb_wx
                    position relative
                    width 143px
                    height 45px
                    border: 1px solid #006E9B
                    border-radius 3px
                    cursor pointer
                    img
                        margin-top 6px
                .pay_img_zfb_wx_active:before
                    content: ''
                    display block
                    width 10px
                    height 10px
                    position absolute
                    bottom -6px
                    left 64px
                    border-bottom 1px solid #00c901
                    border-right 1px solid #00c901
                    transform rotate(45deg)
                    background-color #fff
                .pay_img_zfb
                    float left
                    border-color #006E9B
                    &:before
                        border-color #006E9B
                .pay_img_wx
                    // float right
                    margin: 0 auto
                    border-color #00c901
                    .pay_img_wx_text
                        margin-left 5px
                        vertical-align top
                        color #515151
                        font-size 16px
                    &:before
                        border-color #00c901
            .QR_code
                margin 40px auto 0
                width 152px
                height 152px
                border 1px solid #e0e0e0
            .tip_text
                margin-top 10px
                color #6c6c6c
            .warning
                font-size 14px
                color #ff1200
            /* 支付成功 */
            .pay_ok_img
                margin-top 110px
                img
                    vertical-align: middle
            .pay_ok_text
                margin-top 13px
                color: #80c26a
                font-size 16px
                font-weight: bold
                .pay_ok_goto
                    font-size: 13px
                    color: #7a7a7a
                    font-weight: normal
                    margin-top: 10px
                    span
                        color: #fb0808
            .pay_error_text
                color: #f00
</style>

<template>
    <div class="pay">
        <Modal
            v-model="payModal"
            :closable="false"
            :mask-closable="false"
            width="787"
            class-name="pay_modal">
            <div class="modal_tit pay_tit">付费激活<i class="ivu-icon ivu-icon-ios-close-empty" @click="closeIndent"></i></div>
            <div v-if="!is_pay_ok" class="pay_main">
                <div class="main_tit">
                    客户名称：{{$store.state.mineInfo.real_name || $store.state.mineInfo.name}}<span class="pay_num">（订单号：{{wechatpay.orderno}}）</span>
                </div>
                <div class="pay_table">
                    <Table border :columns="pay_columns" :data="pay_data" :row-class-name="pay_rowClassName"></Table>
                </div>
                <!-- <div class="money original"><span>原价格：￥{{wechatpay.origin_pay}}</span></div> -->
                <div class="money now">应付金额：￥{{wechatpay.pay_price}}</div>
                <div class="pay_img clearfix">
                    <!-- <div class="pay_img_zfb_wx pay_img_zfb" :class="{pay_img_zfb_wx_active: pay_mode == 'zfb'}" @click="clickZFB"><img src="/v1/static/icon/0008.png" width="89" height="31"></div> -->
                    <!-- <span>或</span> -->
                    <div class="pay_img_zfb_wx pay_img_wx" :class="{pay_img_zfb_wx_active: pay_mode == 'wx'}" @click="pay_mode = 'wx'"><img src="/static/icon/0009.png" width="38" height="34"><span class="pay_img_wx_text">微信支付</span></div>
                </div>
                <div class="QR_code" @click="closeWeChatPay" v-html="QRcodeData"></div>
                <div class="tip_text">扫一扫，完成支付</div>
                <div class="warning">扫码支付中,请勿跳转页面,避免支付失败</div>
                <Button style="marginTop: 20px" type="primary" @click="closeIndent">取消订单</Button>
            </div>
            <div v-else class="pay_main">
                <div v-if="statusIsSuccess" class="pay_ok_img"><img src="/static/icon/0007.png" width="79" height="79"></div>
                <div v-if="statusIsSuccess" class="pay_ok_text">
                    <p>订单支付成功!</p>
                    <p class="pay_ok_goto"><span>{{timetoordertime}}s</span> 后跳转</p>
                </div>

                <div v-if="!statusIsSuccess" class="pay_ok_img"><img src="/static/icon/0007_.png" width="79" height="79"></div>
                <div v-if="!statusIsSuccess" class="pay_ok_text pay_error_text">
                    <p>订单支付失败!</p>
                    <Button type="info" @click="rePay" style="margin-top: 20px">重新支付</Button>
                </div>
            </div>
            <Spin size="large" fix v-if="loading">
                <Icon type="load-c" class="spin-icon-load"></Icon>
                <div>加载中...</div>
            </Spin>

            <div slot="footer" v-if="true">
                <!-- <Button type="primary" @click="closeIndent">取消订单</Button> -->
            </div>
        </Modal>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'postPay',
    props:{
        id:Number
    },
    data() {
        return {
            wechatpay: {},
            payModal: true,
            QRcodeData: '', // 二维码
            pay_columns: [
                {
                    title: '收费项目',
                    key: 'product_content'
                },
                // {
                //     title: '订单号',
                //     key: 'product_num'
                // },
                {
                    title: '单价/元',
                    key: 'pay_num'
                },
                {
                    title: '优惠价/元',
                    key: 'discounts'
                },
            ],
            pay_mode: 'wx',
            wechatPayStatusTimer: -1,
            is_pay_ok: false,
            statusIsSuccess: false,
            timetoordertime: 3,
            loading: true,
        }
    },
    computed: {
        pay_data() {
            return [{
                product_content: this.wechatpay.body,
                product_num: this.wechatpay.orderno,
                pay_num: this.wechatpay.order_price,
                discounts: this.wechatpay.pay_price
            }];
        }
    },
    mounted() {
        this.getWechatPay();
    },
    beforeDestroy() {
        window.clearInterval(this.wechatPayStatusTimer);
        // console.log('离开了')
    },
    methods: {
        clickZFB() {
            this.$Modal.warning({
                title: '支付宝支付提示',
                content: '暂不支持支付宝支付！'
            });
        },
        getWechatPay(){
            let url = 'order/getQrcode?type=' + 1 + '&about=' + this.id;  //支付类型（1.商事法律专栏；2.知识；3.课程附件（可能会有））
            this.$http.get(url).then((res) => {
                // console.log('qweqwe',res);
                let data = res.data.data;
                if (res.data.retcode === RETCODE_OK) {
                    this.wechatpay = data;
                    this.getqrcode(data.qrcode_url);
                }else {
                    this.$Message.info({
                        content: res.data.errmsg,
                        duration: 10,
                        closable: true
                    });
                }
                this.loading = false;
            }).catch(err => {
                // 请求失败回调
                this.loading = false;
                console.log('订单信息获取失败！');
            })
        },
        /* 获取支付二维码 */
        getqrcode(qrcodeurl) {
            this.$http.get(`/qrcode?url=${qrcodeurl}`).then((response) => {
                // 请求成功回调
                let data = response.data;
                this.QRcodeData = data;
                this.postPay();
            }).catch(err => {
                // 请求失败回调
                console.log('订单信息获取失败！');
            })
        },
        //支付成功
        paySuccess(){
            this.$emit('paySuccess');
        },
        /* 轮循查看订单状态 */
        postPay() {
            window.clearInterval(this.wechatPayStatusTimer);
            this.wechatPayStatusTimer = window.setInterval(() => {
                this.checkPayStatus();
            },5000);
        },
        /* 检测订单状态 */
        checkPayStatus() {
            let URL = `/order/checkWxOrderStatus?pay_id=${this.wechatpay.orderno}`;
            this.$http.get(URL).then((response) => {
                // 请求成功回调
                let data = response.data;
                if (data.retcode === RETCODE_OK) {
                    if(data.status === 'SUCCESS') {
                        this.statusIsSuccess = true;
                        this.is_pay_ok = true;
                        window.clearInterval(this.wechatPayStatusTimer);
                        this.timeToOrderList();
                    }else if (data.status === 'CLOSED' || data.status === 'PAYERROR') {
                        this.statusIsSuccess = false;
                        this.is_pay_ok = false;
                        window.clearInterval(this.wechatPayStatusTimer);

                    } else {
                        console.log('正在支付中...');
                    }

                }else {
                    this.$Message.warning({
                        content: `查询失败: ${data.errmsg.err_code_des}err_code: ${data.errmsg.err_code}`
                    });
                }
            }).catch(err => {
                // 请求失败回调
                console.log('订单信息获取失败！');
            });
        },
        rePay() {
            this.is_pay_ok = false;
            this.closeWeChatPay();
        },
        /* 关闭订单 */
        closeWeChatPay() {
            let param = {'pay_id':this.wechatpay.orderno};
            this.$http.post(`/wechatpayclose`,param).then((response) => {
                // 请求成功回调
                let data = response.data;
                if (data.retcode === RETCODE_OK) {
                    console.log('关闭订单信息成功');
                    this.getWechatPayInfo();
                } else {
                    console.log(data.errmsg);
                }
            }).catch(err => {
                console.log('关闭订单信息失败！')
            });
        },

        pay_rowClassName(row,index) {
            return 'pay-table-row';
        },
        close() {
            this.$emit('close');
        },
        timeToOrderList() {
            setTimeout(() => {
                if( this.timetoordertime <= 1 ){
                    this.paySuccess();
                    this.$emit('close');
                }else{
                    this.timetoordertime -= 1;
                    this.timeToOrderList();
                }
            }, 1000);
        },
        closeIndent() {
            let param = {
                pay_id : this.wechatpay.orderno
            }
            this.$ajax('post', '/wechatpayclose', param, res => {
                // console.log(res)
                if (res.retcode === 0) {
                    this.close()
                    window.clearInterval(this.wechatPayStatusTimer);
                }
                
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/postPay.vue